import React, { useState, useCallback, useEffect } from "react";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Container, Resizer } from "./styles";
import ReactParseHTML from "react-html-parser";

const TextEditor = (props) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    // const resizer = document.getElementsByClassName('resizer')[0];
    // resizer.addEventListener('mousedown', () => alert('down'));

    const resizer = document.createElement("div");
    resizer.classList.add("resizer");
    const demoEditor = document.querySelector(".demo-wrapper");
    demoEditor.appendChild(resizer);

    function makeResizableDiv(div) {
      const element = document.querySelector(div);
      const resizers = document.querySelectorAll(".resizer");
      const minimum_size = 20;
      let original_width = 0;
      let original_height = 0;
      let original_x = 0;
      let original_y = 0;
      let original_mouse_x = 0;
      let original_mouse_y = 0;
      for (let i = 0; i < resizers.length; i++) {
        const currentResizer = resizers[i];
        currentResizer.addEventListener("mousedown", function (e) {
          e.preventDefault();
          original_width = parseFloat(
            getComputedStyle(element, null)
              .getPropertyValue("width")
              .replace("px", "")
          );
          original_height = parseFloat(
            getComputedStyle(element, null)
              .getPropertyValue("height")
              .replace("px", "")
          );
          original_x = element.getBoundingClientRect().left;
          original_y = element.getBoundingClientRect().top;
          original_mouse_x = e.pageX;
          original_mouse_y = e.pageY;
          window.addEventListener("mousemove", resize);
          window.addEventListener("mouseup", stopResize);
        });

        function resize(e) {
          // if (currentResizer.classList.contains('bottom-right')) {
          const width = original_width + (e.pageX - original_mouse_x);
          const height = original_height + (e.pageY - original_mouse_y);
          if (width > minimum_size) {
            element.style.width = width + "px";
          }
          if (height > minimum_size) {
            element.style.height = height + "px";
          }
        }

        function stopResize() {
          window.removeEventListener("mousemove", resize);
        }
      }
    }

    makeResizableDiv(".demo-wrapper");
  }, []);

  const didMount = useCallback(async () => {
    if (props.default) {
      const { contentBlocks, entityMap } = htmlToDraft(props.default);
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState);

      props.text.current = props.default;
      setEditorState(newEditorState);
    }
  }, [props.default]);

  useEffect(() => {
    didMount();
  }, [props.default]);

  const onEditorStateChange = useCallback(
    (editorState) => {
      const newDoubt = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );

      setEditorState(editorState);

      if (props.text) {
        props.text.current = newDoubt;
      }
    },
    [props.text]
  );

  const handleFullscreen = useCallback(() => {
    const wrapper = document.querySelector(".demo-wrapper");

    if (isFullscreen) {
      wrapper.style.height = "250px";
      wrapper.style.width = "auto";
      setIsFullscreen(false);
      return;
    }

    wrapper.style.height = "100vh";
    wrapper.style.width = "100%";

    setIsFullscreen(true);
  }, [isFullscreen]);

  return (
    <Container fullscreen={isFullscreen}>
      {props.haveFullscreen && (
        <button onClick={handleFullscreen}>Fullscreen</button>
      )}
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        editorStyle={{
          border: "1px solid rgba( 0, 0, 0, 0.5)",
          borderRadius: "5px",
          height: "200px",
        }}
        onEditorStateChange={onEditorStateChange}
      />
    </Container>
  );
};

export default TextEditor;
